import { useQuery } from '@tanstack/react-query';

import { profilesApi } from '@/api';

export const useGetChat = (id: string | number) => {
    return useQuery({
        queryKey: [`chat-${id}`],
        queryFn: () => profilesApi.getChat(id),
    });
};
